import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { MktVersionTypes } from "components/mkt/mktVersionUtils";

export default function useMixpanelProfileMkt(version: MktVersionTypes) {
  return useCallback(
    (properties: { [key: string]: any }) => {
      try {
        const instance = (mixpanel as any).promotion;

        if (!instance) {
          console.error(`Mixpanel ${version} instance not found!`);
          return;
        }

        if (!instance.people) {
          console.error(`Mixpanel ${version} instance.people not found!`);
          return;
        }

        instance.people.set(properties, (response: any) => {
          if (response === 1 || response?.status === 1) {
          } else {
            console.error(
              "Failed to send people properties. Response:",
              response
            );
          }
        });
      } catch (error) {
        console.error("Error setting mixpanel people properties:", error);
      }
    },
    [version]
  );
}
